import * as React from 'react';

const SvgAutomaticText = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <g>
        <path
          fill={fill}
          d="M15.771 13.686l-7.19 5.135a1 1 0 01-1.162 0l-7.365-5.26a2 2 0 00-.054.447v8a2 2 0 002 2h12a2 2 0 002-2v-8a1.991 1.991 0 00-.027-.27c-.068-.017-.136-.033-.202-.052z"
        />
        <path
          fill={fill}
          d="M8 16.778l5.67-4.05a8.136 8.136 0 01-.949-.72H2a2.031 2.031 0 00-.555.087zM18-.008a6 6 0 106 6 6.007 6.007 0 00-6-6zm3 7h-4v-5h2v3h2z"
        />
      </g>
    </svg>
  );
};

export default SvgAutomaticText;
